/* eslint-disable @typescript-eslint/no-explicit-any */
export class MockAsyncLocalStorage {
    getStore() {
        return undefined;
    }
    run(_store, callback) {
        return callback();
    }
}
const mockAsyncLocalStorage = new MockAsyncLocalStorage();
class AsyncLocalStorageProvider {
    getInstance() {
        return (globalThis.__lc_tracing_async_local_storage ??
            mockAsyncLocalStorage);
    }
    initializeGlobalInstance(instance) {
        if (globalThis.__lc_tracing_async_local_storage === undefined) {
            globalThis.__lc_tracing_async_local_storage = instance;
        }
    }
}
const AsyncLocalStorageProviderSingleton = new AsyncLocalStorageProvider();
export { AsyncLocalStorageProviderSingleton };
